import React, { Component } from 'react'
import { translate } from '../../utils/useful'
import FixedView from '../FixedView'
import IntractionActionsList from '../IntractionActionsList'
import Collapsible from 'react-collapsible'

export default class AppletFrame extends Component {
    state = {

    }

    changeCollapse = () => {
        let main = this.state.main
        this.setState({ main: !main })
    }

    render() {
        return (
            <div>
                <button onClick={() => this.framesOptionsList.showView()} ref={el => this.framesNode = el} className='flexc mrd-2'>
                    <div className='flexcc pld-3 prd-4 py-1 br-5 dark-blur-bg'>
                        <div className='flexcc mrd-1'>
                            <img className={this.props.invert ? 'invert' : ''} width={18} src="/assets/icons/applets/database/frame-white.svg" />
                        </div>
                        <p className='font-size-14 ' style={{ color: this.props.color ?? '#fff' }}>{this.props.currentFrame?.name ?? translate('appletframe.Frames')}</p>
                    </div>
                </button>
                <FixedView width={this.props.width} zIndex={10} ref={el => this.framesOptionsList = el} nodeRef={this.framesNode} xOffset={-12} bottomOffset={27} topOffset={0} maxWidth={260} >
                    <div className='bg-white br-10 p-2 shadow-3 sc-gray2 ' style={{ maxHeight: '350px', overflowY: 'scroll' }}>
                        <div className='white-bg' style={{}}>
                            <div className='br-5' style={{ backgroundColor: '#F6F6F6', overflow: 'hidden' }}>
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}appletframe.Pin Frames", icon: "/assets/icons/applets/database/pin-purple.svg" }} />
                                {/* {list?.map((prop, index) => {
                                        let name = 'form'
                                        return (
                                            <div className='bb-gray pt-2'>
                                                <button className={'flexcb p-2 w-100 hover-gray2'} style={{ backgroundColor: (prop._id == this.props.currentFrame._id ? '#E0E0EB' : '') }} onClick={() => this.changeFrame(prop)} >
                                                    <div className=' flexc'>
                                                        <p className='text-left w-100' style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", }}>{prop.name}</p>
                                                    </div>
                                                    {prop._id == this.props.currentFrame._id &&
                                                        <div className='flexcc'>
                                                            <img width={18} src='/assets/icons/check-purple.svg' />
                                                        </div>
                                                    }
                                                </button>
                                            </div>
                                        )
                                    })} */}
                            </div>
                        </div>
                    </div>
                </FixedView >
            </div >
        )
    }
}
